import { render, staticRenderFns } from "./claimwise_listing.vue?vue&type=template&id=5caae137&"
import script from "./claimwise_listing.vue?vue&type=script&lang=js&"
export * from "./claimwise_listing.vue?vue&type=script&lang=js&"
import style0 from "./claimwise_listing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports